import React from 'react';
import { GeckoBtn } from 'ui';
import emptyStateBg from '../../../../assets/empty-state.svg';
import './index.scss';

const ConversationErrorContainer = ({ icon, title, description, button }) => {
  return (
    <div className="ConversationErrorContainer">
      <div className="empty-state d-flex flex-column align-items-center">
        <div className="empty-state-bg" style={{backgroundImage: `url(${emptyStateBg})`}}>
        </div>
        <div className="empty-state-icon">
          <i className={`${icon}`}></i>
        </div>
        <div className="empty-state-content text-center">
          <h2>{title}</h2>
          <p>{description}</p>
          <div className="empty-state-btns">{button ? <GeckoBtn {...button} /> : null}</div>
        </div>
      </div>
    </div>
  );
};

export default ConversationErrorContainer;